// Generated by ReScript, PLEASE EDIT WITH CARE


function fromString(value) {
  switch (value) {
    case "Customer" :
        return /* Customer */1;
    case "Partner" :
        return /* Partner */2;
    default:
      return /* All */0;
  }
}

function toString(value) {
  switch (value) {
    case /* All */0 :
        return "All";
    case /* Customer */1 :
        return "Customer";
    case /* Partner */2 :
        return "Partner";
    
  }
}

var user_types = {
  hd: /* All */0,
  tl: {
    hd: /* Customer */1,
    tl: {
      hd: /* Partner */2,
      tl: /* [] */0
    }
  }
};

export {
  user_types ,
  fromString ,
  toString ,
  
}
/* No side effect */
